import { cartOrderPublicClient } from './client';

export interface RedeemGiftCardInput {
  code: string;
}

interface RedeemGiftCardResponse {
  amountRedeemedInCents: number;
  amountRemainingInCents: number;
  creditAfterRedemptionInCents: number;
}
/**
 *
 * POST `/accounts/redeem-gift-card`
 *
 * Redeems a gift card for an existing user hitting cart-order-svc.
 */
export const redeemGiftCard = async ({
  code,
}: RedeemGiftCardInput): Promise<RedeemGiftCardResponse> => {
  const { data } = await cartOrderPublicClient(1).post<RedeemGiftCardResponse>(
    '/accounts/redeem-gift-card',
    {
      code,
    },
  );

  return data;
};
